import { createSharedComposable } from '@vueuse/core';
import { useDetailRoute } from '../use-detail-route';
import _ from 'lodash';
import { Toast } from 'patsnap-biz';
import { useI18n } from '@/presentation/composables/common/use-i18n';
import { useDetailRouterValidate } from '../use-detail-router-validate';
export const useInitCurrentFolder = createSharedComposable(() => {
    const { folderId } = useDetailRoute();
    const { initDetailRouter } = useDetailRouterValidate();
    const { t } = useI18n();
    function showNoFolderErrorTip() {
        Toast({
            type: 'error',
            message: t('commonStatusCode.70110200'),
            duration: 5000,
            showClose: true,
        });
    }
    function initCurrentFolder(folderList) {
        if (folderId.value) {
            initDetailRouter(folderId.value);
        }
        else {
            const targetFolderId = _.get(folderList, '[0].folder_id');
            if (targetFolderId) {
                initDetailRouter(targetFolderId);
            }
            else {
                showNoFolderErrorTip();
            }
        }
    }
    return {
        initCurrentFolder,
        showNoFolderErrorTip,
    };
});
